import { render, staticRenderFns } from "./EntryMessageHistoryFromApplicant.vue?vue&type=template&id=73cd28d9"
import script from "./EntryMessageHistoryFromApplicant.vue?vue&type=script&lang=js"
export * from "./EntryMessageHistoryFromApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports